import { useState, useEffect } from 'react';
import { t } from '@bg-shared/business/Translate';

export const useShuffleDeck = (nextDrawShuffleDeck: boolean): string => {
    const [message, setMessage] = useState<string>(null);

    useEffect(() => {
        setMessage(nextDrawShuffleDeck ? t.string('shuffle_deck') : null);
    }, [nextDrawShuffleDeck]);

    return message;
};
